import { Injectable } from '@angular/core';
import { BaseService, httpOptions } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs/index';

const USER_TYPE_SUPPLIER = '0';

@Injectable({ providedIn: 'root' })
export class PersonService extends BaseService {

  private url = 'api/person';  // URL to web api
  private purl = 'api/person-vm';  // URL to web api

  currentPerson: any = {};


  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return this.url;
  }

  getPUrl(): string {
    return this.purl;
  }

  //是否供应商
  public isSupplier(): Observable<boolean> {
    let result: boolean;
    let isSupplierSource = new Subject<any>();
    let isSupplier$ = isSupplierSource.asObservable();
    if (this.currentPerson.id) {
      result = this.currentPerson.user.userType == USER_TYPE_SUPPLIER;
      isSupplierSource.next(result);
    } else {
      this.getCurrent().subscribe((data) => {
        this.currentPerson = data;
        result = this.currentPerson.user.userType == USER_TYPE_SUPPLIER;
        isSupplierSource.next(result);
      });
    }
    return isSupplier$;
  }

  /**
   * 获取当前登入人员
   * @param type
   * @returns {Observable<any|any>}
   */
  getCurrent(): Observable<any> {
    const url = `${this.getUrl()}/current`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getLoginPerson`)),
      catchError(this.handleError<any>(`getLoginPerson`)),
    );
  }

  //人员信息赋值
  getAndSetCurrentPerson() {
    this.getCurrent().subscribe((data) => {
      this.currentPerson = data;
    });
  }

  personCard(id): Observable<any> {
    const url = `${this.getUrl()}/person-card`;
    return this.http.get<any>(url, { params: { id: id } }).pipe(
      tap(_ => this.log(`personCard`)),
      catchError(this.handleError<any>(`personCard`)),
    );
  }

  turnPerson(id): Observable<any> {
    const url = `${this.getUrl()}/turn-person`;
    return this.http.get<any>(url, { params: { id: id } }).pipe(
      tap(_ => this.log(`turn-person`)),
      catchError(this.handleError<any>(`turn-person`)),
    );
  }

  getLoginSubordinate() {
    const url = `${this.getUrl()}/subordinate`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`turn-person`)),
      catchError(this.handleError<any>(`subordinate`)),
    );
  }

  updatePerson(object: any): Observable<any> {
    return this.http.put<any>(this.getUrl() + '/update', object, httpOptions).pipe(
      tap(_ => this.log(`updated object =${object}`)),
      catchError(
        this.handleError<any>('updateany'),
      ),
    );
  }

  getPerson(code: String): Observable<any> {
    const url = `${this.getPUrl() + '/get-by-code'}/${code}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`personCard`)),
      catchError(this.handleError<any>(`personCard`)),
    );
  }

  infoAdjust(object: any): Observable<any> {
    return this.http.put<any>(this.getUrl() + '/info-adjust', object, httpOptions).pipe(
      tap(_ => this.log(`infoAdjust object =${object}`)),
      catchError(
        this.handleError<any>('infoAdjust'),
      ),
    );
  }
}

